.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  min-height: var(--touch-target);
  padding: 0 var(--space-4);
  border: 1px solid transparent;
  border-radius: var(--radius-md);
  font-size: var(--text-base);
  font-weight: var(--weight-medium);
  line-height: var(--leading-tight);
  text-decoration: none;
  cursor: pointer;
  transition:
    background-color var(--duration-fast) var(--ease-out),
    border-color var(--duration-fast) var(--ease-out),
    opacity var(--duration-fast) var(--ease-out);
}

.button:disabled,
.button[aria-disabled="true"] {
  opacity: 0.5;
  cursor: not-allowed;
}

.full {
  width: 100%;
}

.size-sm {
  min-height: var(--space-6);
  padding: 0 var(--space-3);
  font-size: var(--text-sm);
}

.size-lg {
  min-height: var(--space-7);
  padding: 0 var(--space-5);
  font-size: var(--text-lg);
}

.primary {
  background: var(--action);
  color: var(--action-text);
}
.primary:hover:not(:disabled) {
  background: var(--action-hover);
}

.secondary {
  background: var(--surface-raised);
  border-color: var(--border-strong);
  color: var(--text-primary);
}
.secondary:hover:not(:disabled) {
  background: var(--surface-sunken);
}

.ghost {
  background: transparent;
  color: var(--text-secondary);
}
.ghost:hover:not(:disabled) {
  background: var(--surface-sunken);
  color: var(--text-primary);
}

.danger {
  background: var(--intent-danger);
  color: var(--grey-0);
}
.danger:hover:not(:disabled) {
  filter: brightness(0.92);
}

.spinner {
  width: 1em;
  height: 1em;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: var(--radius-full);
  animation: spin var(--duration-slow) linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(1turn);
  }
}
